import React from 'react'
import { Linking } from 'react-native'
import { StyleSheet } from 'react-native'
import { txt } from '../../../locales/i18n'
import { CustomText } from '../../text/StyledText'
import Colors from '../../../constants/Colors'
import CustomDialog, {
  ActionButton,
  ContentContainer,
} from '../../dialogs/CustomDialog'
import CustomPressable from "../../pressables/CustomPressable"

export function MunicipalityInfoDialog(props) {
  return (
    <CustomDialog visible={props.visible} {...props}>
      <ContentContainer>
        <CustomText>
          {txt('profile.dialogText')}
          <CustomPressable onPress={() => Linking.openURL('mailto:' + txt('profile.support'))}>
            <CustomText style={styles.linkText}>
              {txt('profile.support')}
            </CustomText>
          </CustomPressable>
        </CustomText>
      </ContentContainer>
      <ActionButton onPress={props.onPress}>
        {txt('profile.dialog')}
      </ActionButton>
    </CustomDialog>
  )
}

export function MunicipalityChangedDialog(props) {
  return (
    <CustomDialog visible={props.visible} {...props}>
      <ContentContainer>
        <CustomText>{txt('profile.municipalityChangedText1')}</CustomText>
        <CustomText font="italic">
          {txt('profile.municipalityChangedText2')}
        </CustomText>
      </ContentContainer>
      <ActionButton onPress={props.onPress}>{txt('dialog.ok')}</ActionButton>
      {props.children}
    </CustomDialog>
  )
}

export function LanguageChangedDialog(props) {
  return (
    <CustomDialog visible={props.visible} {...props}>
      <ContentContainer>
        <CustomText>{txt('settings.languageChangedText')}</CustomText>
      </ContentContainer>
      <ActionButton onPress={props.onPress}>{txt('dialog.ok')}</ActionButton>
      {props.children}
    </CustomDialog>
  )
}

const styles = StyleSheet.create({
  linkText: {
    color: Colors.blue,
  },
})
